<p-confirmDialog key="importblocked" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="ItemBorder">
	<h4 style="text-align: center">Instructions</h4>
	<ul>
		<li>
			<label>Create a .CSV or Textfile with a list of people you want to block</label>
		</li>

		<li>
			<label>Pick what each column stands for. Note: Column options in <span style="color: red">Red</span> are required, the rest are optional.</label>
		</li>

		<li>
			<label
				>Select image files if you have photos for some of your visitors. The names of the image files will have to match a column in the import file
				Ex. photo is called JohnDoe.jpg, the import file must have "JohnDoe.jpg" in that visitor's Photo column</label
			>
		</li>

		<li>
			<label>Press Finish to update the list of blocked visitors</label>
		</li>
	</ul>

	<h4 style="text-align: center">Allowed Values:</h4>
	<div class="AllowedValueDiv">
		<label>Visitor Types (Defaults to Other):</label>
		<div class="OptionScroller">
			<ul>
				<li *ngFor="let x of lstVisitorType">
					<label>{{ x.VisitorTypeDesc }}</label>
				</li>
			</ul>
		</div>

		<label>Visitor Statuses (Defaults to Deny Entry):</label>
		<div class="OptionScroller">
			<ul>
				<li *ngFor="let x of lstVisitorStatus">
					<label>{{ x.VisitorStatusDesc }}</label>
				</li>
			</ul>
		</div>

		<label>Races (Defaults to Not Provided):</label>
		<div class="OptionScroller">
			<ul>
				<li *ngFor="let x of lstRace">
					<label>{{ x.RaceDesc }}</label>
				</li>
			</ul>
		</div>

		<label>Ethnicities (Defaults to Not Provided):</label>
		<div class="OptionScroller">
			<ul>
				<li *ngFor="let x of lstEthnicity">
					<label>{{ x.EthnicityDesc }}</label>
				</li>
			</ul>
		</div>
	</div>
</div>

<!--Options-->
<div class="ItemBorder TopMargin">
	<div class="SelectButtonsGrid">
		<label>Select Block List</label>
		<input
			[disabled]="IsLoading() == true"
			id="SelectedImportFile"
			type="file"
			(change)="onSelectedImportFileChange($event)"
			onclick="event.target.value=''"
			style="visibility: hidden; position: absolute"
			accept=".csv, .txt"
		/>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSelectImportFile()">Select File</button>

		<label>Select Images</label>
		<input
			[disabled]="IsLoading() == true"
			id="SelectedImportImages"
			type="file"
			(change)="onSelectedImportImagesChange($event)"
			onclick="event.target.value=''"
			style="visibility: hidden; position: absolute"
			accept="image/*"
			multiple
		/>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSelectImportImages()">Select Images</button>
	</div>
	<div *ngIf="ImageParsing == true" class="LoadingImageTextDiv">
		<label>...Please wait loaded {{ SuccessCount }} of {{ PhotoDisplayCount }}</label>
	</div>
	<div *ngIf="ImageParsing == false && TotalImagesLoaded.length > 0" class="LoadingImageTextDiv">
		<label>{{ TotalImagesLoaded.length }} Photos Loaded </label>
	</div>
</div>

<!--Table-->
<div class="ItemBorder TopMargin">
	<h4 style="text-align: center">Preview</h4>

	<div class="OptionDiv">
		<label>Skip First Line:</label>
		<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="SkipFirstLine" (ngModelChange)="onSkipFirstLineChange($event)" />
	</div>

	<div *ngIf="lstPreviewImportList.length > 0">
		<p-table
			#mydt
			[value]="lstPreviewImportList"
			[loading]="Parsing"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header" let-ImportData>
				<tr style="height: 4rem">
					<th *ngIf="PreviewImage == true"></th>

					<th *ngFor="let o of lstPreviewImportList[0]; let i = index">
						<select
							[disabled]="IsLoading() == true"
							class="form-control"
							[(ngModel)]="lstColumnHeaders[i]"
							(ngModelChange)="onColumnHeaderChange($event, i)"
							[style.color]="lstColumnHeaders[i].Required == true ? 'Red' : 'Black'"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of lstColumnOptions" [ngValue]="o" [style.color]="o.Required == true ? 'Red' : 'Black'">
								{{ o.Description }}
							</option>
						</select>
					</th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-ImportData>
				<tr>
					<td *ngIf="PreviewImage">
						<img [src]="GetImportDataImage(ImportData)" class="VisitorImage" />
					</td>
					<td *ngFor="let x of ImportData" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ x }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-success" (click)="onFinish()">Finish</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning SmallLeftMargin" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
